import { createSlice } from '@reduxjs/toolkit';

export const modalSlice = createSlice({
    name: 'modal',
    initialState: {
        isModalVisible: false,
    },
    reducers: {
        setModalVisible: (state, action) => {
            state.isModalVisible = action.payload;
        },
    },
});

export const { setModalVisible } = modalSlice.actions;

export default modalSlice.reducer;